export const LABEL_TYPE = 'Label Type';
export const WITH_LOGO_LABEL_NAME = 'Shamrock';
export const WITHOUT_LOGO_LABEL_NAME = 'Plain';
export const VALIDATION_ERROR_CODE_INVALID_JOBSHIFTJOB = 'VALIDATION_ERROR_CODE_INVALID_JOBSHIFTJOB';
export const VALIDATION_ERROR_STATUS_INVALID_JOBSHIFTJOB = '400';

export const MANUFACTURE_SAVE_MESSAGE = '';
